<template>
    <label class="text-sm block text-cavilam-primary font-semibold" for="nationalite">
        {{ __('Nationalite') }} <sup class="text-red-500">*</sup>
    </label>
    <select id="nationalite" name="nationalite" v-model="$parent.form.nationalite"
            class="w-full px-2 py-2 text-gray-700 rounded cursor-pointer border-cavilam-primary"
            :required="required"
            :class="{'pointer-events-none cursor-default opacity-75':readonly}">
        <option :value="null"> -- {{ __('veuillez_selectionner_nationalite') }} -- </option>
        <option v-for="pays in liste" :value="pays.code">{{ pays.libelle }}</option>
    </select>
    <p class="text-red-500 text-xs" :class="{'invisible':!$parent.form.errors.nationalite}">
        {{ __($parent.form.errors.nationalite) }}
    </p>
</template>

<script>
export default {
    name: "NationaliySelector.vue",
    props: {
        liste: Array,
        required: Boolean,
        readonly: Boolean
    },
}
</script>

<style scoped>

</style>
